module.exports = __webpack_public_path__ + "static/img/declare_five.b96fd1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/declare_five.jpg
// module id = y1R5
// module chunks = 1